import { render, staticRenderFns } from "./EditCalendarModal.vue?vue&type=template&id=48b71d28&scoped=true"
import script from "./EditCalendarModal.vue?vue&type=script&lang=js"
export * from "./EditCalendarModal.vue?vue&type=script&lang=js"
import style0 from "./EditCalendarModal.vue?vue&type=style&index=0&id=48b71d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b71d28",
  null
  
)

export default component.exports